<!--
 * @Author: RYL
 * @Description: 终端详情组件
 * @Date: 2020-10-22 17:53:30
 * @LastEditTime: 2022-03-22 09:13:51
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="$t('lang.terminalList.TerminalDetails')"
      :visible.sync="dialogVisible"
      center
      width="40%"
    >
      <el-divider content-position="left" class="divider-text">{{
        $t("lang.terminalList.Basicinformation")
      }}</el-divider>
      <div class="detail-form">
        <el-form
          label-width="128px"
          style="width: 350px;"
          label-position="right"
        >
          <el-form-item :label="$t('lang.openvpn.name') + '：'">
            <span>{{ terminalForm.name }}</span>
          </el-form-item>
          <el-form-item label="SN：">
            <span>{{ terminalForm.sn }}</span>
          </el-form-item>
          <el-form-item label="Did：">
            <span>{{ terminalForm.did }}</span>
          </el-form-item>
          <el-form-item :label="$t('lang.terminalList.templateName') + '：'">
            <span>{{ terminalForm.mname }}</span>
          </el-form-item>
        </el-form>
      </div>
      <el-divider content-position="left" class="divider-text">{{
        $t("lang.terminalList.Protocolinformation")
      }}</el-divider>
      <div class="detail-form">
        <el-form
          label-width="140px"
          style="width: 350px;"
          label-position="right"
        >
          <el-form-item :label="$t('lang.openvpn.name') + '：'">
            <span>{{ protocolOptions[terminalForm.protocol] }}</span>
          </el-form-item>
          <div v-if="terminalForm.protocol == 1">
            <el-form-item :label="$t('lang.terminalList.Slaveaddress') + '：'">
              <span>{{ terminalForm.tcpProtocol.ip }}</span>
            </el-form-item>
            <el-form-item :label="$t('lang.terminalList.Port') + '：'">
              <span>{{ terminalForm.tcpProtocol.port }}</span>
            </el-form-item>
            <el-form-item :label="$t('lang.terminalList.SlaveID') + '：'">
              <span>{{ terminalForm.tcpProtocol.sid }}</span>
            </el-form-item>
          </div>
          <div v-else-if="terminalForm.protocol == 2">
            <el-form-item :label="$t('lang.terminalList.SerialportNo') + '：'">
              <span>{{ terminalForm.rtuProtocol.com }}</span>
            </el-form-item>
            <el-form-item :label="$t('lang.terminalList.SlaveID') + '：'">
              <span>{{ terminalForm.rtuProtocol.sid }}</span>
            </el-form-item>
            <el-form-item :label="$t('lang.repeater.baudrate') + '：'">
              <span>{{ terminalForm.rtuProtocol.bps }}</span>
            </el-form-item>
            <el-form-item :label="$t('lang.repeater.data_bits') + '：'">
              <span>{{ terminalForm.rtuProtocol.dataBit }}</span>
            </el-form-item>
            <el-form-item :label="$t('lang.repeater.parity') + '：'">
              <span>{{ terminalForm.rtuProtocol.checkBit }}</span>
            </el-form-item>
            <el-form-item :label="$t('lang.repeater.stop_bits') + '：'">
              <span>{{ terminalForm.rtuProtocol.stopBit }}</span>
            </el-form-item>
            <el-form-item :label="$t('lang.repeater.flow') + '：'">
              <span>{{ terminalForm.rtuProtocol.xon }}</span>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="mini" type="primary" @click="dialogVisible = false">{{
          $t("lang.terminalList.Confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { terminalDetail } from "@/api/cloudMonitor/terminalList";
export default {
  data() {
    return {
      dialogVisible: false,
      terminalForm: {},
      // 协议
      protocolOptions: {
        "1": "Modbus TCP",
        "2": "Modbus RTU",
        "3": "IO Control",
      },
    };
  },
  methods: {
    show(id) {
      terminalDetail({ id }).then((res) => {
        if (res.data.code === 0) {
          this.terminalForm = res.data.data;
        } else {
          this.$message.error("请求失败");
        }
        this.dialogVisible = true;
      });
    },
  },
};
</script>
<style scoped>
.detail-form {
  display: flex;
  justify-content: center;
  /* margin-left: 200px; */
}
.divider-text {
  color: red;
}
.el-form-item {
  margin-bottom: 0px;
}
</style>
